
import React from 'react'
import classNames from 'classnames';
import '../css/navbar.css'
import {BsPlus} from 'react-icons/bs'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";
  import { Collapse } from '@mui/material';
  import tags from '../data/tags';
  import Masonry from 'react-masonry-css'


const Questions = [
    {"Number": 1, 
    "Question": "How do I book a coaching session?",
    "Answer": <div className="FAQAnswer">
        <p>To book a session, simply get in touch by email (hello@archjob.co.uk). Once I understand which session is right for you, I’ll share availability and next steps, along with a PayPal payment link to confirm your booking.</p>
        </div>},

    // {"Number": 2, 
    // "Question": "Not sure if you need a career coach?",
    // "Answer": <div className="FAQAnswer">
    //     <p>Let's find out. We can arrange a 15-minute free call for a quick chat. <a href="https://www.archjobs.co.uk/architectural-career-coaching/check-out?package=call" target="_blank" rel="noopener">Either click the link here</a> or use the chat function on the bottom right of this page.</p>
    //     </div>},

    {"Number": 3, 
    "Question": "How are coaching sessions conducted?",
    "Answer": <div className="FAQAnswer">
    <p>All sessions are held online via Google Meet or Microsoft Teams. You’ll receive a link once your session is confirmed.</p>
    </div>},

    {"Number": 4, 
    "Question": "Who are these sessions for?",
    "Answer": <div className="FAQAnswer">
    <p>These sessions are designed for architectural professionals at different stages of their career - including graduates, job seekers looking to improve their CV or portfolio and overseas-qualified candidates planning a move to the UK or Dubai.</p>
    </div>},
   
    {"Number": 5, 
    "Question": "Which coaching packages do you offer?",
    "Answer": <div className="FAQAnswer">
               <p>We are offering 4 different coaching sessions.</p>
                <ul>
                  <li>CV Review</li>
                  <li>CV + Portfolio Review</li>
                  <li>Strategy Call | UK</li>
                  <li>Strategy Call | Dubai</li>
                </ul>
              </div>},
    
    {"Number": 6, 
    "Question": "Will you write my CV or portfolio for me?",
    "Answer": <div className="FAQAnswer">
        <p>No - I do not write CVs or portfolios. My role is to provide clear, honest feedback so you understand what to improve and how to present your experience more effectively. </p>
        </div>},
   
    {"Number": 8, 
    "Question": "Can you help if I’m not based in the UK or Dubai?",
    "Answer": <div className="FAQAnswer">
        <p>Yes - I work with professionals from different backgrounds and locations. If you’re targeting the UK or Dubai market, I can help you understand how to position yourself effectively.</p>
    </div>},
 
    {"Number": 9, 
    "Question": "Can I get a refund if I change my mind?",
    "Answer": <div className="FAQAnswer">
        <p>Payments are non-refundable once your session has been confirmed. If you have any questions beforehand, feel free to get in touch so we can make sure the session is the right fit.</p>
    </div>},

    {"Number": 10, 
    "Question": "Are coaching sessions confidential?",
    "Answer": <div className="FAQAnswer">
    <p>Yes - all coaching sessions are completely confidential.</p>
    </div>},

//     {"Number": 11, 
//     "Question": "Will Aylin write my CV for me?",
//     "Answer": <div className="FAQAnswer">
//     <p>No, Aylin won't write your CV for you. Instead, she'll offer advice and explain areas for improvement. Her aim is to help you understand the principles of a strong CV and focus on developing the skills to create one yourself in the future.</p>
//     </div>},

//     {"Number": 12, 
//     "Question": "After I purchased a package, can I cancel it?",
//     "Answer": <div className="FAQAnswer">
//     <p>No, every package is non refundable.</p>
//     {/* <p>If you are unsure whether booking a coaching session is the right decision, we can arrange a 15-minute free call. <a href="https://www.archjobs.co.uk/architectural-career-coaching/check-out?package=call" target="_blank" rel="noopener">You can either click the link here</a> or use the chat function on the bottom right of this page. </p> */}
//     </div>},

//     {"Number": 13, 
//     "Question": "What's the difference between a Career Coach & a Mentor?",
//     "Answer": <div className="FAQAnswer">
//     <p>A Career Coach provides structured, goal-oriented guidance to achieve your desired career goals, while a Mentor is an experienced professional who offers voluntary, informal support based on their own experiences and expertise.
// </p>
//     </div>},

    // {"Number": 14, 
    // "Question": "Still have a question?",
    // "Answer": <div className="FAQAnswer">
    // <p>Please email your question to Aylin at <a href="mailto:hello@archjobs.co.uk">aylin@archjobs.co.uk</a>
    // </p>
    // </div>},
]


class FAQCoaching extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: [],
            layout: "Default"
        };  
    }    
    
      componentDidMount = () => {
        window.addEventListener("resize", this.getSize.bind(this));

      }
    
      getSize = () => {
        var pagewidth = window.innerWidth
        var layout = "Default"
        if (pagewidth < 600){
          layout = "Mobile"
        }
        if (this.state.layout !== layout){
          this.setState({layout: layout})
        }
      }

      toggleQuestion = (num) => {
        const open = this.state.open
        const index = open.indexOf(num);
        if (index > -1) { // only splice array when item is found
            open.splice(index, 1); // 2nd parameter means remove one item only
        } else {
            open.push(num)
        }
        this.setState({open: open})
      }

    render() {

        var question_list = []

        Questions.forEach(Question => {
            question_list.push(
                <div className="FAQSection">
                    <div className="FAQQuestion" onClick={() => {this.toggleQuestion(Question["Number"])}}>
                        <BsPlus className="PlusIcon"/> {Question["Question"]}
                    </div>
                    <Collapse in={this.state.open.includes(Question["Number"])}>
                        {Question["Answer"]}
                    </Collapse>
                </div>)
        })


      return (
        <div className="TeamPage">
            <div className="FAQContainer">
                
                <div className="FAQContent">
                    <div className="FAQTitle">FAQ - Coaching</div>
                    <p>We've collected the answers to some of our frequently asked questions below. Hopefully this helps clarify more about the Coaching Sessions but as always, feel <a target="_blank" href="mailto:hello@archjobs.co.uk">free to reach out to us</a> directly if you have any further questions.</p>
                    {/* <div className="FAQSubTitle">We've collected the answers to some of our frequently asked questions below. Hopefully this helps clarifiy more about our service but as always, feel free to reach out to us directly if your question isn't covered below.</div> */}
                    <Masonry
                        breakpointCols={this.state.layout == "Mobile"? 1: 2}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column">
                        {question_list}
                    </Masonry>
                    {/* <div className="FAQContact">
                        Can't find what you're looking for? <a href="mailto:hello@archjobs.co.uk">Contact</a> the ArchJobs team.
                    </div> */}
                    
                </div>
                <div className="FAQBackground"> </div>
            </div>
        </div>
      )
    }
  }

  class FAQCoachingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };  
    }    
    
    componentDidMount = () => {
        window.scrollTo(0, 0)
      }
      render() {


      return (
        <div className="TeamPage">
            <FAQCoaching/>
            <div className="WhyWorkWithUsSection">
              <div className="WhyWorkWithUsSectionTitle">Still have a question? Reach out to us via email</div>
              <div className="WhyWorkWithUsSectionSubtitle">Drop us an email at <a href="mailto:hello@archjobs.co.uk">hello@archjobs.co.uk</a></div>
              {/* <div className="WhyWorthWithUsHeaderButton">
                <Link to="/post">
                  <Button btnClassName="PostJobButton">Contact Us</Button>
                </Link>
              </div> */}
            </div>
            <div className="BottomPadding"></div> 
        </div>
      )
    }
  }

  export default FAQCoachingPage
  export { FAQCoaching }